<template>
  <div class="barcode-wrapper">
    <div class="barcode-item" v-for="item in barcodeList" :key="item.value">
      <div class="label">
        <div class="name">{{ item.label }}：</div>
        <div class="content">{{ item.value }}</div>
      </div>
      <barcode class="barcode" :value="item.value" />
    </div>
  </div>
</template>

<script>
import barcode from './barcode.vue';
export default {
  name: 'barcodeBar',
  components: {
    barcode
  },
  props: {
    barcodeList: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped lang="less">
.barcode-wrapper {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  width: 100%;
  overflow: auto;

  .barcode-item {
    display: flex;
    align-items: center;
    padding: 0 24px;
    gap: 20px;
    height: 80px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #f5f5f5;

    .label {
      .name {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 13px;
        color: #262626;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }

      .content {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #262626;
        line-height: 17px;
        text-align: left;
        font-style: normal;
      }
    }

    .barcode {
      flex: 1;
    }
  }
}
</style>
